export default {
  version: 0.1,
  timeout: 60000,
  apiPrefix: "",
  requestRetry: 4,
  requestRetryDelay: 800,
  tokenKey: "Authorization",
  userInfoKey: "USER_INFO",
  permissionsKey: "PERMISSION_ARRAY",
  pageSizesArr: [14, 32, 64]
};
